import { render, staticRenderFns } from "./AssociarQRCode.vue?vue&type=template&id=31a06d13"
import script from "./AssociarQRCode.vue?vue&type=script&lang=js"
export * from "./AssociarQRCode.vue?vue&type=script&lang=js"
import style0 from "./AssociarQRCode.vue?vue&type=style&index=0&id=31a06d13&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports